/* tslint:disable */
/* eslint-disable */
/**
 * mama health backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LandbotSettings } from './LandbotSettings';
import {
    LandbotSettingsFromJSON,
    LandbotSettingsFromJSONTyped,
    LandbotSettingsToJSON,
} from './LandbotSettings';

/**
 * 
 * @export
 * @interface UpdateSettingsDto
 */
export interface UpdateSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSettingsDto
     */
    landbotUrlTx?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSettingsDto
     */
    landbotLanguage?: string;
    /**
     * 
     * @type {Array<LandbotSettings>}
     * @memberof UpdateSettingsDto
     */
    landbotSettings?: Array<LandbotSettings>;
}

/**
 * Check if a given object implements the UpdateSettingsDto interface.
 */
export function instanceOfUpdateSettingsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateSettingsDtoFromJSON(json: any): UpdateSettingsDto {
    return UpdateSettingsDtoFromJSONTyped(json, false);
}

export function UpdateSettingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSettingsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'landbotUrlTx': !exists(json, 'landbotUrlTx') ? undefined : json['landbotUrlTx'],
        'landbotLanguage': !exists(json, 'landbotLanguage') ? undefined : json['landbotLanguage'],
        'landbotSettings': !exists(json, 'landbotSettings') ? undefined : ((json['landbotSettings'] as Array<any>).map(LandbotSettingsFromJSON)),
    };
}

export function UpdateSettingsDtoToJSON(value?: UpdateSettingsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'landbotUrlTx': value.landbotUrlTx,
        'landbotLanguage': value.landbotLanguage,
        'landbotSettings': value.landbotSettings === undefined ? undefined : ((value.landbotSettings as Array<any>).map(LandbotSettingsToJSON)),
    };
}

